export const platformQueryKeys = {
  all: ["app:platform"] as const,
  companyApps: (companyId?: string) =>
    [...platformQueryKeys.all, "companyApps", companyId] as const,
  permissions: (productCode?: string) =>
    [...platformQueryKeys.all, "permissions", productCode] as const,
  adminSettingsProductDetails: (productCode?: string) =>
    [...platformQueryKeys.all, "adminSettingsProductDetails", productCode] as const,
  products: () => [...platformQueryKeys.all, "products"] as const,
  hrUsers: () => [...platformQueryKeys.all, "hrUsers"] as const,
  atsUsers: () => [...platformQueryKeys.all, "atsUsers"] as const,
  atsSecurityGroups: () => [...platformQueryKeys.all, "atsSecurityGroups"] as const,
  hrSecurityGroups: () => [...platformQueryKeys.all, "hrSecurityGroups"] as const,
  securityGroupSummaries: () => [...platformQueryKeys.all, "securityGroupSummaries"] as const,
  securityGroupUsers: (groupId: string) =>
    [...platformQueryKeys.all, "securityGroupUsers", groupId] as const,
};
